import { useEditor } from '@craftjs/core';
import { useEffect, useRef, useState } from 'react';

const useEditableLayer = ({
  text,
  onExitEditing,
  id,
}: {
  text: string;
  onExitEditing?: () => void;
  id: string;
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [textValue, setTextValue] = useState(text);
  const inputTitleRef = useRef<HTMLInputElement | null>(null);
  const { actions } = useEditor();

  useEffect(() => {
    setTextValue(text);
  }, [text]);

  const handleUpdateTitle = (value: string) => {
    if (value.trim() === '') return;
    actions.setCustom(id, (custom) => {
      custom.displayName = value;
    });
  };
  const handleOnBlur = () => {
    setIsEditing(false);
    handleUpdateTitle(textValue);
    onExitEditing?.();
  };
  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTextValue(e.target.value);
  };
  const handleOnKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      setIsEditing(false);
      handleUpdateTitle(textValue);
      onExitEditing?.();
    }
  };
  const handleEnterEditMode = () => {
    setIsEditing(true);
    setTextValue(text);
    if (inputTitleRef.current) {
      inputTitleRef.current.classList.remove('hidden');
      inputTitleRef.current.focus();
    }
  };
  return {
    inputTitleRef,
    isEditing,
    textValue,
    handleOnBlur,
    handleOnChange,
    handleOnKeyUp,
    handleEnterEditMode,
  };
};

export default useEditableLayer;
